import { makeStyles } from "tss-react/mui";

export const useNWONProjectIntroductionSectionStyles = makeStyles()(
  (theme) => ({
    wrapper: {
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.only("xs")]: {
        flexDirection: "column",
      },
    },
    logoContainer: {
      alignItems: "center",
      justifyContent: "center",
    },
    logoWrapper: {
      height: "auto",
      maxWidth: theme.spacing(15),
      "& > svg": {
        width: "100%",
      },
    },
    description: {
      marginBottom: theme.spacing(1),
    },
    website: {
      marginBottom: theme.spacing(1),
      textDecoration: "none",
      color: theme.palette.primary.main,
    },
    info: {
      flexDirection: "column",
    },
  })
);
